import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../assets/css/DigixLeads.css";
import "../assets/css/FinanceManagement.css";
import AccountsReceivable from "./AccountsReceivable";
import FinanceAccounts from "./FinanceAccounts";
import TenantInvoicesTab from "./TenantInvoicesTab";
import FinanceTenantsTab from "./FinanceTenantsTab";

export const TAB_INVOICES = "Invoices & Payments";
export const TAB_TENANTS = "Tenants";
export const TAB_FINANCE_ACCOUNTS = "Company Accounts";
export const TAB_CUSTOMERS = "Customer Accounts";

const FINANCE_TABS = [
  { key: TAB_INVOICES, label: "Invoices & Payments" },
  { key: TAB_TENANTS, label: "Clients" },
  { key: TAB_CUSTOMERS, label: "Client Accounts" },
  { key: TAB_FINANCE_ACCOUNTS, label: "Company Accounts" },
];

/** @deprecated legacy keys still accepted from old bookmarks/links */
function tabFromRouteState(financeTab, filterClientId) {
  if (financeTab === "customers" || financeTab === "payable") return TAB_CUSTOMERS;
  if (financeTab === "tenants") return TAB_TENANTS;
  if (financeTab === "accounts") return TAB_FINANCE_ACCOUNTS;
  if (financeTab === "invoices" || financeTab === "receivable") return TAB_INVOICES;
  if (filterClientId) return TAB_INVOICES;
  return TAB_INVOICES;
}

function FinanceManagement() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(() =>
    tabFromRouteState(location.state?.financeTab, location.state?.filterClientId)
  );
  const [invoiceFilterClientId, setInvoiceFilterClientId] = useState(
    () => (location.state?.filterClientId != null ? String(location.state.filterClientId) : "")
  );

  useEffect(() => {
    const financeTab = location.state?.financeTab;
    const filterId = location.state?.filterClientId;
    if (
      financeTab === "invoices" ||
      financeTab === "customers" ||
      financeTab === "tenants" ||
      financeTab === "accounts" ||
      financeTab === "payable" ||
      financeTab === "receivable" ||
      filterId != null
    ) {
      setActiveTab(tabFromRouteState(financeTab, filterId));
    }
    if (filterId != null && filterId !== "") {
      setInvoiceFilterClientId(String(filterId));
    }
  }, [location.state?.financeTab, location.state?.filterClientId, location.key]);

  const openInvoicesForTenant = (clientId) => {
    setInvoiceFilterClientId(String(clientId));
    setActiveTab(TAB_INVOICES);
    navigate("/finance-management", {
      replace: true,
      state: { financeTab: "invoices", filterClientId: clientId }
    });
  };

  return (
    <div className="digixleads-container finance-management-page">
      <div className="main-card">
        <div className="page-header">
          <div className="page-header-row">
            <div className="tabs-container">
              {FINANCE_TABS.map((t) => (
                <button
                  key={t.key}
                  type="button"
                  className={`tab-button ${activeTab === t.key ? "active" : ""}`}
                  onClick={() => setActiveTab(t.key)}
                >
                  {t.label}
                </button>
              ))}
            </div>
            <div className="finance-tab-pills" role="tablist" aria-label="Finance section">
              {FINANCE_TABS.map((t) => (
                <button
                  key={t.key}
                  type="button"
                  role="tab"
                  aria-selected={activeTab === t.key}
                  className={`finance-tab-pill${activeTab === t.key ? " is-active" : ""}`}
                  onClick={() => setActiveTab(t.key)}
                >
                  {t.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="finance-management-tab-body">
          {activeTab === TAB_INVOICES && (
            <TenantInvoicesTab
              scope="finance"
              filterClientId={invoiceFilterClientId}
              onFilterClientIdChange={setInvoiceFilterClientId}
            />
          )}
          {activeTab === TAB_TENANTS && <FinanceTenantsTab onOpenInvoices={openInvoicesForTenant} />}
          {activeTab === TAB_FINANCE_ACCOUNTS && <FinanceAccounts />}
          {activeTab === TAB_CUSTOMERS && <AccountsReceivable />}
        </div>
      </div>
    </div>
  );
}

export default FinanceManagement;
